/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { ObjectHelper } from '@fruitpackage/helpers';
import ApplyMixin from '@mixin/apply';
import ErrorResponseMixin from '@mixin/errorResponse';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            next: {
                to: null,
                text: 'Volgende',
                disabled: false,
            },
            prev: {
                to: null,
                text: 'Terug',
                disabled: false,
            },
            autosave: true,
        };
    },

    mixins: [
        ApplyMixin,
        ErrorResponseMixin,
    ],

    computed: {
        ...mapState({
            current: state => state.project.current,
        }),
    },

    created() {
        if (this.onNext) {
            this.next.onNext = this.onNext;
        }
    },

    mounted() {
        this.emitAutosave();
        this.emitNext();
        this.emitPrev();
    },

    beforeDestroy() {
        this.$root.$emit('root::step::next', null);
        this.$root.$emit('root::step::prev', null);
        this.$root.$emit('root::step::autosave', null);
    },

    methods: {
        emitNext() {
            this.$root.$emit('root::step::next', this.next);
        },

        emitPrev() {
            this.$root.$emit('root::step::prev', this.prev);
        },

        emitAutosave() {
            this.$root.$emit('root::step::autosave', this.autosave);
        },
    },

    watch: {
        'post': {
            handler: function (val) {
                const requiredFields = {};
                this.$validator.fields.items.forEach(field => {
                    if (field.isRequired) {
                        requiredFields[field.name] = val[field.name];
                    }
                });

                if (ObjectHelper.isFilled(requiredFields)) {
                    this.$validator.validate().then(valid => {
                        this.next.disabled = !valid;
                    });
                } else {
                    this.next.disabled = true;
                }
            },
            deep: true
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class StepMixin extends Vue {}